import { IncentiveOfferType } from 'modules/incentivesMarket/types';

import { IncentiveOffersListProvider } from '../pages/IncentiveOffersList/context/IncentiveOffersListContext';
import IncentiveOffersList from '../pages/IncentiveOffersList';

const TradingSellOffersListContainer = () => (
  <IncentiveOffersListProvider>
    <IncentiveOffersList incentiveOfferType={IncentiveOfferType.SELL} />
  </IncentiveOffersListProvider>
);

export default TradingSellOffersListContainer;
